/* eslint-disable no-unused-vars */
/* eslint-disable indent */
/* eslint-disable */
import React, { useEffect, useRef, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { embedDashboard } from "@superset-ui/embedded-sdk";
import axios from "axios";
import urls from "../../../api/urls";
import { Card } from "antd";
import Heading from "../../../components/Heading";

const SupersetEmbeddedReport = ({
  guestToken: propGuestToken,
  dashboardId: propDashboardId,
  supersetDomain: propSupersetDomain,
  dashboardUiConfig
}) => {
  const mountRef = useRef(null);
  const [errorMessage, setErrorMessage] = useState("");
  const [searchParams] = useSearchParams();

  // Function to fetch guest token from API
  const fetchGuestToken = async (dashboardId) => {
    try {
      const response = await axios.post(
        urls.FETCH_GUEST_TOKEN,
        {
          username: "datazip.embed@shreemaruti.com",
          password: "JNF0D*fa$cd4",
          user: {
            username: "datazip.embed@shreemaruti.com",
          },
          resources: [
            {
              type: "dashboard",
              id: dashboardId,
            },
          ],
          rls: [],
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      return response.data?.token || response.data;
    } catch (error) {
      console.error("Error fetching guest token:", error);
      throw new Error(
        error.response?.data?.message ||
          error.message ||
          "Failed to fetch guest token"
      );
    }
  };

  useEffect(() => {
    let isMounted = true;

    async function load() {
      setErrorMessage("");
      try {
        // ✅ Get Dashboard ID
        const dashboardId =
          propDashboardId ||
          searchParams.get("dashboardId") ||
          process.env.REACT_APP_SUPERSET_DASHBOARD_ID ||
          "6574c88b-9bb3-4911-8b7d-b6cbbffbbff8";

        // ✅ Get Guest Token (4 ways: prop → URL → API call → hardcoded test token)
        let guestToken =
          propGuestToken || searchParams.get("guestToken");

        // If no token provided, fetch from API
        if (!guestToken) {
          try {
            guestToken = await fetchGuestToken(dashboardId);
          } catch (apiError) {
            console.warn("API token fetch failed, using fallback:", apiError);
            // Fallback to hardcoded token if API fails
            guestToken =
              "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyIjp7InVzZXJuYW1lIjoiZGF0YXppcC5lbWJlZEBzaHJlZW1hcnV0aS5jb20ifSwicmVzb3VyY2VzIjpbeyJ0eXBlIjoiZGFzaGJvYXJkIiwiaWQiOiI2NTc0Yzg4Yi05YmIzLTQ5MTEtOGI3ZC1iNmNiYmZmYmJmZjgifV0sInJsc19ydWxlcyI6W10sImlhdCI6MTc2MjUwMDY1Ni4wMTEzNDc4LCJleHAiOjE3NjI1MDA5NTYuMDExMzQ3OCwiYXVkIjoiaHR0cDovL3N1cGVyc2V0OjgwODgvIiwidHlwZSI6Imd1ZXN0In0.pkBmtAUmkxOu6ZyYmc6uW6BasFLv-wzEu3kZSut_Ruc";
          }
        }

        // ✅ Get Superset Domain
        const supersetDomain =
          propSupersetDomain ||
          searchParams.get("domain") ||
          process.env.REACT_APP_SUPERSET_DOMAIN ||
          "https://reports.a3-framework.prayog.io";

        if (!guestToken) {
          throw new Error(
            "Guest token is required. Provide it via prop, URL (?guestToken=...), or .env variable."
          );
        }

        if (!isMounted) return;

        console.log("✅ Embedding Superset Dashboard:");
        console.log("➡️ Domain:", supersetDomain);
        console.log("➡️ Dashboard ID:", dashboardId);
        console.log("➡️ Guest Token:", guestToken.substring(0, 40) + "...");

        await embedDashboard({
          id: dashboardId,
          supersetDomain,
          mountPoint: mountRef.current,
          fetchGuestToken: async () => guestToken,
          dashboardUiConfig: dashboardUiConfig || {
            hideTitle: false,
            hideChartControls: true,
            filtersVisible: false,
          },
        });
        
        // Apply DataZip UI styling to iframe
        setTimeout(() => {
          const iframe = mountRef.current?.querySelector("iframe");
          if (iframe) {
            iframe.style.height = "80vh";
            iframe.style.width = "100%";
            iframe.style.border = "none";
          }
        }, 100);
      } catch (err) {
        console.error("❌ Error embedding Superset:", err);
        if (!isMounted) return;
        setErrorMessage(err?.message || "Failed to load dashboard");
      }
    }

    load();
    return () => {
      isMounted = false;
    };
  }, [
    propGuestToken,
    propDashboardId,
    propSupersetDomain,
    searchParams,
    dashboardUiConfig,
  ]);

  return (
    <Card className="hub-cp-container" style={{ background: "transparent", boxShadow: "none", border: "none" }}>
      <Heading title="Embedded Superset Dashboard" />
      {errorMessage ? (
        <div style={{ color: "#d4380d", marginBottom: 8, padding: "8px" }}>{errorMessage}</div>
      ) : null}
      <div style={{ paddingTop: "8px" }}>
        <div
          ref={mountRef}
          style={{
            width: "100%",
            minHeight: "80vh",
          }}
        />
      </div>
    </Card>
  );
};

export default SupersetEmbeddedReport;
